<template>
  <div>
    <div class="dashboard__tab dashboard__profile-tab">
      <b-tabs>
        <b-tab title="Members" active>
          <div class="success__wrap" v-if="success">
            <span class="success">{{ successMessage }}</span>
            <svgicon icon="cancel" class="success__icon"></svgicon>
          </div>
          <select
            name=""
            v-model="sort"
            id=""
            class="form__select dashboard__filter"
          >
            <option :value="null" disabled selected>Filter</option>
            <option value="all">All</option>
            <option value="host">Host</option>
            <option value="approved">Approved</option>
            <option value="declined">Declined</option>
            <option value="pending">Pending</option>
            <option value="none">None</option>
          </select>
          <div class="dashboard__container ">
            <input
              type="text"
              class="form__input dashboard__search"
              v-model="searchQuery"
              placeholder="Search by member's name"
              @keyup.enter="handleSearchMembers"
            />
            <svgicon
              icon="cancel"
              class="cancel_icon"
              @click.prevent="clearSearchBar"
            ></svgicon>
          </div>

          <section class="dashboard__listing-desktop">
            <div
              class="dashboard__payment-history-wrap dashboard__overview-table"
              v-if="members.length > 0"
            >
              <table class="dashboard__payment-history-table">
                <thead>
                  <tr>
                    <th class="dashboard__payment-history-table-heading"></th>
                    <th class="dashboard__payment-history-table-heading">
                      First name
                    </th>
                    <th class="dashboard__payment-history-table-heading">
                      Last name
                    </th>
                    <th class="dashboard__payment-history-table-heading">
                      KYC status
                    </th>
                    <th class="dashboard__payment-history-table-heading">
                      Host email
                    </th>
                    <th class="dashboard__payment-history-table-heading">
                      Last login
                    </th>
                    <th class="dashboard__payment-history-table-heading">
                      Date joined
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <router-link
                    tag="tr"
                    :to="
                      `/member-details/${member.id}?page=${getPages}&currentPage=${curPage}`
                    "
                    v-for="(member, index) in filteredMembers"
                    :key="index"
                    style="cursor:pointer"
                  >
                    <td
                      class="dashboard__payment-history-table-data dashboard__listing-table"
                    >
                      {{ pageNumber(index + 1) }}
                    </td>
                    <td
                      class="dashboard__payment-history-table-data dashboard__listing-table"
                    >
                      {{ member.userKyc.firstname | capitalize }}
                    </td>
                    <td
                      class="dashboard__payment-history-table-data dashboard__listing-table"
                    >
                      {{ member.userKyc.lastname | capitalize }}
                    </td>
                    <td
                      class="dashboard__payment-history-table-data dashboard__listing-table"
                    >
                      <span
                        class="dashboard__payment-history-table-status"
                        :class="[
                          { pending: member.kycStatus == 'pending' },
                          { approve: member.kycStatus == 'approved' },
                          { decline: member.kycStatus == 'declined' },
                          { none: member.kycStatus == 'none' }
                        ]"
                        >{{ member.kycStatus | capitalize }}</span
                      >
                    </td>
                    <td
                      class="dashboard__payment-history-table-data dashboard__listing-table"
                    >
                      {{ member.email }}
                    </td>
                    <td
                      class="dashboard__payment-history-table-data dashboard__listing-table"
                    >
                      {{
                        member.lastLoggedIn
                          | formatNowDate
                          | capitalizeFirstLetter
                      }}
                    </td>
                    <td
                      class="dashboard__payment-history-table-data dashboard__listing-table"
                      v-html="formatDate(member.createdAt)"
                    ></td>
                  </router-link>
                </tbody>
              </table>
            </div>
          </section>

          <section class="dashboard__listing-mobile" v-if="members.length > 0">
            <router-link
              tag="div"
              :to="'/member-details/' + member.id"
              class="dashboard__payment-history-resp"
              v-for="(member, index) in filteredMembers"
              :key="index"
              style="cursor:pointer"
            >
              <div class="dashboard__listing-mobile-wrap">
                <div class="dashboard__listing-mobile-detail w-100">
                  <div class="dashboard__payment-history-resp-details">
                    <p class="dashboard__payment-history-resp-name">
                      {{ member.userKyc.firstname | capitalize }}
                      {{ member.userKyc.lastname | capitalize }}
                    </p>
                    <p class="dashboard__payment-history-resp-others">
                      Host: {{ getRole(member.role) | capitalize }}
                    </p>
                  </div>
                  <div class="dashboard__payment-history-resp-details">
                    <p
                      class="dashboard__payment-history-resp-name"
                      v-html="`Joined: ${formatDate(member.createdAt)}`"
                    ></p>
                    <p class="dashboard__payment-history-resp-others">
                      Login:
                      {{
                        member.lastLoggedIn
                          | formatNowDate
                          | capitalizeFirstLetter
                      }}
                    </p>
                  </div>

                  <div class="dashboard__payment-history-resp-download">
                    <span
                      class="dashboard__payment-history-table-status"
                      :class="[
                        { pending: member.kycStatus == 'pending' },
                        { approve: member.kycStatus == 'approved' },
                        { decline: member.kycStatus == 'declined' },
                        { none: member.kycStatus == 'none' }
                      ]"
                      >{{ member.kycStatus | capitalize }}</span
                    >
                  </div>
                </div>
              </div>
            </router-link>
          </section>

          <div class="dashboard__pagination">
            <b-pagination
              v-if="members.length > 0"
              pills
              v-model="curPage"
              :total-rows="count"
              :per-page="pageSize"
              prev-text="Prev"
              next-text="Next"
              first-number
              last-number
              @change="handlePagination"
            ></b-pagination>
          </div>
          <div class="listingEmpty__content mt-5" v-if="numberOfLisitng == 0">
            <h6 class="listingEmpty__greeting">Hello Admin</h6>
            <p class="listingEmpty__info">
              There are no members
            </p>

            <div class="listingEmpty__card-wrap">
              <div class="listingEmpty__card">
                <div class="listingEmpty__card-img first">
                  <img
                    src="../../assets/images/listingEmpty-icon-one.svg"
                    class="img-fluid"
                    alt
                  />
                </div>
              </div>
            </div>
          </div>
        </b-tab>
        <b-tab
          title="Deactivate request"
          v-if="deactivationRequests.length > 0"
        >
          <div
            class="dashboard__payment-history-wrap dashboard__overview-table"
          >
            <table class="dashboard__payment-history-table">
              <thead>
                <tr>
                  <th class="dashboard__payment-history-table-heading">
                    name
                  </th>
                  <th class="dashboard__payment-history-table-heading">
                    email
                  </th>
                  <th class="dashboard__payment-history-table-heading">
                    phone
                  </th>

                  <th class="dashboard__payment-history-table-heading">
                    Reasons
                  </th>
                  <th class="dashboard__payment-history-table-heading">
                    Status
                  </th>
                  <th class="dashboard__payment-history-table-heading">
                    Date Created
                  </th>
                  <th class="dashboard__payment-history-table-heading">
                    Last updated
                  </th>
                  <th class="dashboard__payment-history-table-heading">
                    Action
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(request, index) in deactivationRequests"
                  :key="index"
                >
                  <td
                    class="dashboard__payment-history-table-data dashboard__listing-table"
                  >
                    {{ request.firstname | capitalize }}
                    {{ request.lastname | capitalize }}
                  </td>
                  <td
                    class="dashboard__payment-history-table-data dashboard__listing-table"
                  >
                    {{ request.email }}
                  </td>
                  <td
                    class="dashboard__payment-history-table-data dashboard__listing-table"
                  >
                    {{ request.phone }}
                  </td>
                  <td
                    class="dashboard__payment-history-table-data dashboard__listing-table"
                  >
                    <p>
                      {{ request.reason }}
                    </p>
                    <p>
                      {{ request.moreInformation }}
                    </p>
                  </td>
                  <td
                    class="dashboard__payment-history-table-data dashboard__listing-table"
                  >
                    <span
                      class="dashboard__payment-history-table-status"
                      :class="[
                        { pending: request.status == 'pending' },
                        { approve: request.status == 'resolved' },
                        { decline: request.status == 'approved' }
                      ]"
                      >{{ request.status | capitalize }}</span
                    >
                  </td>
                  <td
                    class="dashboard__payment-history-table-data dashboard__listing-table"
                    v-html="formatDate(request.createdAt)"
                  ></td>
                  <td
                    class="dashboard__payment-history-table-data dashboard__listing-table"
                    v-html="formatDate(request.updatedAt)"
                  ></td>
                  <td
                    class="dashboard__payment-history-table-data dashboard__listing-table"
                  >
                    <b-dropdown
                      id="dropdown-left"
                      size="lg"
                      variant="link"
                      toggle-class="text-decoration-none"
                      no-caret
                    >
                      <template v-slot:button-content>
                        <svgicon
                          icon="table-menu"
                          class="dashboard__listing-table-menu"
                        ></svgicon>
                      </template>
                      <b-dropdown-item
                        @click="deactivationAction(request.id, 'resolve')"
                        >Resolve</b-dropdown-item
                      >
                      <b-dropdown-item
                        @click="deactivationAction(request.id, 'deactivate')"
                        >Approve</b-dropdown-item
                      >
                    </b-dropdown>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </b-tab>
      </b-tabs>
    </div>

    <loader :loader="loader"></loader>
  </div>
</template>

<script>
import {
  getMembers,
  deactivationRequest,
  deactivationAction
} from "../../../services/member";
import loader from "../resuables/loader";
import { formatReadbleDate } from "../../utils/index";
import moment from "moment";
export default {
  name: "members",
  components: {
    loader
  },
  data() {
    return {
      members: [],
      numberOfLisitng: null,
      successMessage: "",
      success: false,
      loader: false,
      sort: "all",
      filteredMembers: [],
      showDisapproveModal: false,
      listingId: null,
      reasonNote: null,
      declineLoading: false,
      searchQuery: "",
      searchKey: "title",
      deactivationRequests: [],
      currentPage: 1,
      pageSize: 20,
      count: 0,
      pages: 0,
      kycStatus: ""
    };
  },
  methods: {
    pageNumber(index) {
      if (this.currentPage < 2) {
        return index;
      } else {
        return this.pageSize * (this.currentPage - 1) + index;
      }
    },
    clearSearchBar() {
      this.searchQuery = "";
      this.getMembers();
    },
    getMembers() {
      this.loader = true;
      getMembers(this.getPages, this.pageSize, this.searchQuery, this.kycStatus)
        .then(data => {
          if (data.statusCode == 200) {
            this.loader = false;
            this.members = data.data.users;
            this.count = data.data.totalUsers;
            this.filteredMembers = this.members;
            this.filteredMembers.sort(
              (d1, d2) =>
                new Date(d2.updated_at).getTime() -
                new Date(d1.updated_at).getTime()
            );
          }
        })
        .catch(err => {
          this.loader = false;
          return err;
        });
    },
    handlePagination(value) {
      if (value == 1) {
        this.pages = 0;
      } else {
        this.pages = (value - 1) * this.pageSize;
      }
      this.currentPage = value;
      this.$router.push(
        `/members?page=${this.currentPage}&kycStatus=${this.kycStatus}&name=${this.searchQuery}`
      );
    },
    handleSearchMembers() {
      this.$router.replace(
        `/members?page=${this.currentPage}&kycStatus=${this.kycStatus}&name=${this.searchQuery}`
      );
      this.getMembers();
    },
    deactivationRequest() {
      deactivationRequest()
        .then(data => {
          if (data.statusCode == 200) {
            this.deactivationRequests = data.data;
          }
        })
        .catch(err => {
          return err;
        });
    },
    deactivationAction(reasonId, status) {
      let data = {
        updateStatus: status
      };
      deactivationAction(reasonId, data)
        .then(data => {
          if (data.statusCode == 200) {
            this.deactivationRequest();
            this.$notification.success({
              message: "Resolved",
              description: `Resolved`
            });
          }
        })
        .catch(err => {
          return err;
        });
    },
    formatDate(date) {
      return formatReadbleDate(date);
    },
    getRole(roleObj) {
      for (const property in roleObj) {
        if (roleObj.hasOwnProperty("host")) {
          return "yes";
        } else {
          return "no";
        }
      }
    }
  },
  filters: {
    capitalize(value) {
      if (!value) return "";
      value = value.toString();
      return value.charAt(0).toUpperCase() + value.slice(1);
    },
    formatNowDate(value) {
      if (!value) return "";
      if (value) {
        return moment(value).fromNow();
      }
    },
    capitalizeFirstLetter(value) {
      if (!value) return "";
      if (value) {
        return value.charAt(0).toUpperCase() + value.slice(1);
      }
    }
  },
  watch: {
    $route() {
      this.getMembers();
    },
    sort(newValue) {
      this.page = 0;
      if (newValue === "all") {
        this.kycStatus = "";
        this.$router.replace(`/members?page=1`);
        this.getMembers();
      } else {
        this.kycStatus = newValue;
        this.$router.replace(
          `/members?page=1&kycStatus=${this.kycStatus}&name=${this.searchQuery}`
        );
        this.getMembers();
      }
    }
  },
  computed: {
    getPages() {
      return this.$route.query.page || 0;
    },
    curPage: {
      get() {
        return this.$route.query.currentPage || 1;
      },
      set(value) {
        this.currentPage = value;
      }
    }
  },
  mounted() {
    const { status, page, name } = this.$route.query;
    if (page) {
      this.currentPage = Number(page);
    }
    if (status) {
      this.status = status;
    }
    if (name) {
      this.searchQuery = name;
    }
    this.deactivationRequest();

    this.getMembers();
  },
  beforeMount() {}
};
</script>



// WEBPACK FOOTER //
// src/components/dashboard/members.vue